import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

//Bootstrap
import { Form } from "react-bootstrap";

//UI components
import FormFieldCurrency from "../../../ui/FormFieldCurrency";
import ErrorMessage from "../../../ui/ErrorMessage";

//Validation schema
import formEditNacrtovanaVrednostSchema from "../../../../config/formEditNacrtovanaVrednost";

//API calls
import { useEditNacrtovaneVrednostiProjekta } from "../../../../services/ProjectDetails/financeAPI";

const NacrtovanaVrednostProjektaEditFrom = ({
  setIsEditing,
  nacrtovaneVrednosti,
}) => {
  const { id } = useParams();
  const schema = useMemo(() => formEditNacrtovanaVrednostSchema, []);

  //PUT edit nacrtovane vrednosti projekta
  const {
    mutate: editNacrtovaneVrednosti,
    isPending: isPendingEdit,
    isError,
    error,
    reset: resetMutationError,
  } = useEditNacrtovaneVrednostiProjekta(id);

  const {
    handleSubmit,
    formState: { errors, isDirty },
    control,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      nacrtovanaVrednost: nacrtovaneVrednosti?.nacrtovanaVrednost,
      nacrtovaniProjektniViri: nacrtovaneVrednosti?.nacrtovaniProjektniViri,
    },
  });

  const onSubmit = (data) => {
    const payload = {
      nacrtovanaVrednost: data?.nacrtovanaVrednost,
      nacrtovaniProjektniViri: data?.nacrtovaniProjektniViri,
    };

    editNacrtovaneVrednosti(payload, {
      onSuccess: () => {
        setIsEditing(false);
      },
      onError: () => setTimeout(() => resetMutationError(), 3000),
    });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <FormFieldCurrency
        label="Vrednost projekta"
        name="nacrtovanaVrednost"
        control={control}
        validationError={errors.nacrtovanaVrednost?.message}
      />
      <FormFieldCurrency
        label="Sofinanciranje iz projektnega vira"
        name="nacrtovaniProjektniViri"
        control={control}
        validationError={errors.nacrtovaniProjektniViri?.message}
      />
      <button
        type="submit"
        className="btn btn-primary mt-3"
        disabled={!isDirty || isPendingEdit}
      >
        {isPendingEdit ? "Shranjevanje..." : "Shrani"}
      </button>
      <button
        type="button"
        className="btn btn-secondary mt-3 ms-2"
        onClick={() => setIsEditing(false)}
      >
        Prekliči
      </button>
      {isError && <ErrorMessage message={error.message} />}
    </Form>
  );
};

export default NacrtovanaVrednostProjektaEditFrom;
